export const environment = {
  production: true,
  apiUrl: 'https://api.justteach.ai',
  sentryEnabled: true,
};

